Vendd.Scripts.load(function () {

    var $wrapper = $('.x-product-bundle-table'), wrapper;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    var lazyLoadPrices = $('.list-lazy-load-prices', $wrapper).first().text().toLowerCase().trim() === "true";

    var intRegex = /^[0-9]*$/;
    var decRegex = /^[0-9]*(\.[0-9]+)$/;

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var parentProductPrice = $('.x-product-details .pd-box .prices-container .current-price-container .current-price').text();
        var totalPrice = Number(parentProductPrice.replace(/[^0-9\,]+/g, "").replace(/\,/g, '.'));
        var choise = 0;
        $('.x-bundle-item').each(function () {
            var itemPrice = $(this).data('price');
            var itemPriceN = Number(itemPrice.replace(/[^0-9\,]+/g, "").replace(/\,/g, '.'));
            var qty = $('.qty-spinner-input', $(this)).val();
            if ($('.choise-select', $(this)).is(':checked')) {
                choise = 1;
            } else {
                choise = 0;
            }

            var totalItemPrice = itemPriceN * qty * choise;

            $(this).closest('.x-bundle-item').find('.current-price').html(CurrencyFormatted(itemPriceN));

            totalPrice = totalPrice + totalItemPrice;
        });

        $('.total .right-column', $wrapper).html(CurrencyFormatted(totalPrice));

        wrapper.loading(false);
    };

    $wrapper.on('change', '.choise-select.js-selector', function (e) {
        var $this = $(this);
        var choise = $this.val();
        var price;

        if ($(this).is(':checked') ) {
            price = $this.closest('.x-bundle-item').data('price');

            $this.closest('.x-bundle-item').removeClass('disabled');
            $this.closest('.x-bundle-item').find('.qty-spinner-input').removeClass('disabled');
            $this.closest('.x-bundle-item').find('.current-price').html(price);
            $this.closest('.x-bundle-item').find('.js-plus').prop('disabled', false);
            $this.closest('.x-bundle-item').find('.js-minus').prop('disabled', false);
        } else {
            price = '0,00 €';

            $this.closest('.x-bundle-item').addClass('disabled');
            $this.closest('.x-bundle-item').find('.qty-spinner-input').addClass('disabled');
            $this.closest('.x-bundle-item').find('.current-price').html(price);
            $this.closest('.x-bundle-item').find('.js-plus').prop('disabled', true);
            $this.closest('.x-bundle-item').find('.js-minus').prop('disabled', true);
        }

        wrapper.update();
    });

    $wrapper.on('click', '.js-minus', function (e) {

        var $this = $(this);

        if ($this.closest('.x-bundle-item').hasClass('disabled'))
            return;

        var quanta = $this.closest('.bundle-qty-spinner').data('quanta'), qty;

        var $field = $this.closest('.bundle-quantity-selector').find('.js-selector');

        if (intRegex.test(quanta)) {
            qty = parseInt($field.val()) - parseInt(quanta);
        } else if (decRegex.test(quanta)) {
            qty = parseFloat($field.val()) - parseFloat(quanta);
            qty = qty.toFixed(2);
        }

        if (qty >= quanta) {
            $field.val(qty);
        }

        wrapper.update();
    });

    $wrapper.on('click', '.js-plus', function (event) {

        var $this = $(this);

        if ($this.closest('.x-bundle-item').hasClass('disabled'))
            return;

        var quanta = $this.closest('.bundle-qty-spinner').data('quanta'), qty;

        var $field = $this.closest('.bundle-quantity-selector').find('.js-selector');

        if (intRegex.test(quanta)) {
            qty = parseInt($field.val()) + parseInt(quanta);
        } else if (decRegex.test(quanta)) {
            qty = parseFloat($field.val()) + parseFloat(quanta);
            qty = qty.toFixed(2);
        }
        
        $field.val(qty);

        wrapper.update();
    });

    $wrapper.on('click', '.js-move-all-to-cart', function (e) {
        //set an empty array
        var pdBundleArray = [];

        $('.x-bundle-item:not(.disabled)', $wrapper).each(function () {
            var $box = $(this);
            //set an object with bundle product info
            var product = {
                id: $box.data('identifier'),
                productId: $box.data('productid'),
                skuId: $box.data('variantid'),
                path: $box.data('path'),
                qty: Number($box.find('.qty-spinner-input').val())
            };
            //add object into array
            pdBundleArray.push(product);
        });

        //set multipuple add into cart
        if (pdBundleArray.length > 0) 
            Vendd.MessageBus.publishAsync(e.delegateTarger, new Vendd.Cart.Messages.MultipleAdd(pdBundleArray));

        //triger click into main product to add it into cart
        $('.x-product-details .pd-inner-area-two .x-product-details-ajax-buttons .js-add-to-cart').trigger('click');
    });

    wrapper.update();

    if (lazyLoadPrices) {
        initLazyLoadPrices();
    } else {
        //if user has custom prices -> run initLazyLoadPrices
        Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, $pl, function (envelope) {
            customPrices = envelope.message.data.model.HasCustomPrices;
            if (customPrices) initLazyLoadPrices();
        });
    }

    /* Functionality for Lazy Prices & Availabilities */
    function initLazyLoadPrices() {
        var items = [];

        $('.x-bundle-item[data-variantid]', $wrapper).each(function (i, el) {
            items.push(parseInt($(el).attr('data-variantid')));
        });

        var obj = {
            itemIds: items,
            fetchPrices: true,
            fetchAvailabilities: true,
            fetchStock: true
        };

        Vendd.MessageBus.publishAsync($wrapper, new Vendd.ScrollList.Messages.GetClientProductListData(obj));
    }

    Vendd.MessageBus.unsubscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, $wrapper);

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrapper, function (envelope) {
        var result = JSON && JSON.parse(envelope.message.data) || $.parseJSON(envelope.message.data);

        $('.x-bundle-item[data-variantid]:not(.prices-lazyloaded)', $wrapper).each(function (i, el) {
            var itemVariantId = parseInt($(el).attr('data-variantid'));
            var itemData = result.Products.filter(function (a) { return a.VariantId === itemVariantId });

            if (itemData.length === 0) return;

            //update current price
            var prices = itemData[0].Prices.Price;

            if (prices) {
                var currentPrice = prices.ShowPriceWithoutVat ? prices.CurrentPriceWithoutVat : prices.CurrentPrice;
                $('.current-price', $(el)).text(currentPrice);
                $(el).data('price', currentPrice);
            }

            $(el).addClass('prices-lazyloaded');

            //update availability
            var availability = itemData[0].Availability.AvailabilityData;

            if (availability) {
                var $availabilityCont = $('.availability-container', $(el));
                $availabilityCont.empty().append('<span class="availability pd-availability-' + availability.AvailabilityActionId + '">' + availability.Name + '</span>');
            }

            $(el).addClass('availabilities-lazyloaded');
        });
    });

    Vendd.MessageBus.publish(wrapper, new Vendd.Product.Messages.BindControl($wrapper));

    function CurrencyFormatted(amount) {
        var i = parseFloat(amount);
        if (isNaN(i)) { i = 0.00; }
        var minus = '';
        if (i < 0) { minus = '-'; }
        i = Math.abs(i);
        i = parseInt((i + .005) * 100);
        i = i / 100;
        s = new String(i);
        if (s.indexOf('.') < 0) { s += '.00'; }
        if (s.indexOf('.') == (s.length - 2)) { s += '0'; }
        s = (minus + s).replace(/\./g, ',') + ' €';
        return s;
    }

    //reset choise options before leave the page
    addEventListener("beforeunload", (event) => {
        $('.choise-select.js-selector', $wrapper).each(function () {
            var $select = $(this);

            $('option:first', $select).prop('selected', true);
        });
    });
});